module.exports = __webpack_public_path__ + "img/chesterLogo.9780c09c.png";